import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import validators from '../shared/validators';

function ExtraDataModal(props) {
    const [currentErrorMessage, setCurrentErrorMessage] = useState(null);

    const inputRef = React.createRef();

    const styles = {
        errorMessage: {
            color: '#dc3545',
        },
        errorInput: {
            borderColor: '#dc3545',
        },
        phoneStart: {
            position: 'absolute',
            left: '28px',
            top: '46px',
        },
        phoneInput: {
            paddingLeft: '40px',
        },
    };

    const isValid = () => {
        if (props.isRequired && (inputRef.current.value === '' || inputRef.current.value === null)) {
            setCurrentErrorMessage(<FormattedMessage id="required-message" defaultMessage="Required" />);
            return false;
        }
        if (props.fieldType === 'phone' && (validators.phone(inputRef.current.value) !== undefined || inputRef.current.value.length !== 8)) {
            setCurrentErrorMessage(<FormattedMessage id="invalid-phone-number" defaultMessage="Invalid phone number" />);
            return false;
        }
        setCurrentErrorMessage(null);
        return true;
    };

    /**
     * @param {string} response ['accept' | 'cancel']
     */
    const onResponse = (response) => {
        if (response === 'accept' && !isValid()) {
            return;
        }
        props.onResponse(response, inputRef.current.value);
    };

    return (
        <div>
            <Modal
                show
                size="sm"
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-lg">
                        <FormattedMessage id="extra-data-modal-title" defaultMessage="We need more information to add this product" />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <label htmlFor={props.fieldType} className="form-label">
                            {props.label}
                        </label>
                        {props.fieldType === 'phone' && (<span style={styles.phoneStart}>+53 </span>)}
                        <input
                            ref={inputRef}
                            required={props.isRequired}
                            type="text"
                            className="form-control"
                            id={props.fieldType}
                            maxLength={props.fieldType === 'phone' ? '8' : false}
                            style={{ ...(currentErrorMessage && styles.errorInput), ...(props.fieldType === 'phone' && styles.phoneInput) }}
                            onChange={() => isValid()}
                        />
                        {currentErrorMessage && (
                            <div className="invalid-feedback" style={styles.errorMessage}>
                                {currentErrorMessage}
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" style={{ marginRight: '15px' }} className="button-secondary button-small" onClick={() => onResponse('accept')}>
                        <FormattedMessage id="modal-zoneSelect-accept" defaultMessage="Accept" />
                    </button>
                    <button type="button" className="button-cancel button-small" onClick={() => onResponse('cancel')}>
                        <FormattedMessage id="modal-zoneSelect-cancel" defaultMessage="Cancel" />
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default ExtraDataModal;



/** WEBPACK FOOTER **
 ** ./src/components/product/extra-data-modal.js
 **/